import React, { useState, useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";
import firebase from "../../Firebase/firebase";
import "firebase/firestore";
import { useQuery } from "@apollo/client";
import { BUILDING_LIST_QUERY } from "lib/buildings";
import Page from "components/Page";
import Toolbar from "components/Layout/Toolbar";
import { GetBuildingsQueryResult, Building } from "generated/graphql";
import clsx from "clsx";
import {
  Avatar,
  Box,
  Paper,
  Container,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  makeStyles,
  Button,
  LinearProgress,
} from "@material-ui/core";
import PerfectScrollbar from "react-perfect-scrollbar";
import { AuthContext } from "Firebase/AuthProvider";
import { BuildingContext } from "Context/BuildingProvider";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    minHeight: "100%",
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  avatar: {
    marginRight: theme.spacing(2),
  },
}));

const Dashboard = () => {
  const history = useHistory();
  const classes = useStyles();
  const { setRoute } = useContext(AuthContext);
  useEffect(() => {
    setRoute("Dashboard");
  }, []);
  const { currentBuilding, updateBuilding } = useContext(BuildingContext);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);
  const { loading, error, data }: GetBuildingsQueryResult = useQuery(
    BUILDING_LIST_QUERY,
    {
      variables: {
        //email: user?.email,
        limit,
        offset: page,
      },
    }
  );
  const handleClick = (event: any) => {
    event.preventDefault();

    firebase
      .auth()
      .signOut()
      .then((res) => {
        history.push("/auth/login");
      });
  };

  const handleLimitChange = (event: any) => {
    setLimit(event.target.value);
  };

  const handlePageChange = (event: any, newPage: any) => {
    setPage(newPage);
  };

  const handleBuildingOpen = (
    building: Pick<
      Building,
      "BuildingName" | "Id" | "LastUpdateDateTime" | "centerLat" | "centerLong"
    >
  ): void => {
    if (!!updateBuilding) {
      updateBuilding(building);
      history.push("/app/livescreen");
    } else {
      console.log("update was undefined");
    }
  };
  if (loading) {
    return <LinearProgress />;
  } else if (error) {
    return <div>{error.message}</div>;
  } else if (!!data?.Building) {
    return (
      <Page title="Buildings">
        {/*<Toolbar />*/}
        <Paper className="container">
          <PerfectScrollbar>
            <Box>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Name</TableCell>
                    <TableCell>Open</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data.Building.slice(0, limit).map(
                    (
                      building: Pick<
                        Building,
                        | "BuildingName"
                        | "Id"
                        | "LastUpdateDateTime"
                        | "centerLat"
                        | "centerLong"
                      >
                    ) => (
                      <TableRow
                        hover
                        key={building.Id}
                        //selected={selectedCustomerIds.indexOf(customer.id) !== -1}
                      >
                        <TableCell component="th" scope="row">
                          {building.BuildingName}
                        </TableCell>
                        <TableCell>
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={() => {
                              handleBuildingOpen(building);
                            }}
                          >
                            Select
                          </Button>
                        </TableCell>
                      </TableRow>
                    )
                  )}
                </TableBody>
              </Table>
            </Box>
          </PerfectScrollbar>
          <TablePagination
            component="div"
            count={
              data.Building_aggregate.aggregate?.count
                ? data.Building_aggregate.aggregate?.count
                : 0
            }
            onChangePage={handlePageChange}
            onChangeRowsPerPage={handleLimitChange}
            page={page}
            rowsPerPage={limit}
            rowsPerPageOptions={[5, 10, 25]}
          />
        </Paper>
      </Page>
    );
  } else {
    return <div>No Buildings</div>;
  }
};
export default Dashboard;
